import { TopNavigationProps } from '@amzn/awsui-components-react/polaris/top-navigation';
import { AppTopNavigation } from '@amzn/event-engine-js-utils';
import { AuthContext } from 'contexts/AuthProvider';
import getDecodedToken from 'contexts/AuthProvider/utils/get-decoded-token';
import React, {
    ComponentProps,
    FC,
    useContext,
    useEffect,
    useState,
} from 'react';
import { useHistory } from 'react-router-dom';

import { routes } from './../../constants';
import { MenuDropdownItemId } from './types';

export interface AppTopNavProps {
    id?: string;
}

const AppTopNav: FC<AppTopNavProps> = ({ id }) => {
    const { getCurrentSession, signOut } = useContext(AuthContext);
    const history = useHistory();
    const appNavigationIdentity: ComponentProps<
        typeof AppTopNavigation
    >['identity'] = {
        href: routes.landingPage,
        onFollow: (e: any) => {
            e.preventDefault();
            history.push(routes.landingPage);
        },
    };
    const [utilities, setUtilities] = useState<TopNavigationProps.Utility[]>();

    useEffect(() => {
        getCurrentSession().then((currentSession) => {
            if (!currentSession) {
                return;
            }

            const decodedToken = getDecodedToken(currentSession);
            const email = decodedToken.email || '';
            const name =
                [decodedToken.given_name, decodedToken.family_name]
                    .filter((n) => !!n)
                    .join(' ') ||
                decodedToken.name ||
                decodedToken['cognito:username'];

            setUtilities([
                {
                    type: 'menu-dropdown',
                    iconName: 'user-profile',
                    text: name,
                    description: email,
                    onItemClick: (e) => {
                        switch (e.detail.id) {
                            case MenuDropdownItemId.SignOut:
                                signOut();
                                return;
                        }
                    },
                    items: [
                        {
                            id: MenuDropdownItemId.SignOut,
                            text: 'Sign out',
                        },
                    ],
                },
            ]);
        });
    }, []);

    return (
        <AppTopNavigation
            id={id}
            identity={appNavigationIdentity}
            utilities={utilities}
            sticky
        />
    );
};

export default AppTopNav;
